import { render, staticRenderFns } from "./aralmTable.vue?vue&type=template&id=23b8b4c2&scoped=true&"
import script from "./aralmTable.vue?vue&type=script&lang=js&"
export * from "./aralmTable.vue?vue&type=script&lang=js&"
import style0 from "./aralmTable.vue?vue&type=style&index=0&id=23b8b4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8b4c2",
  null
  
)

export default component.exports